import React from 'react';
import { LoginButton, LoginPopupButtonContainer } from './StyledLoginWithPopup';

export const LoginWithPopup = ({ onClick }) => (
  <LoginPopupButtonContainer>
    <LoginButton onClick={onClick}>This action requires signing in</LoginButton>
  </LoginPopupButtonContainer>
);
